import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/menu_icons/Cereri_si_Oferte.png'


const _withScopeId = n => (_pushScopeId("data-v-0c26c92e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "q-pa-sm ecran-container"
}
const _hoisted_2 = { class: "text-blue" }
const _hoisted_3 = {
  class: "app__color--semigray",
  style: {"padding-top":"2rem","padding-bottom":"2rem"}
}
const _hoisted_4 = { class: "app__label--large" }
const _hoisted_5 = {
  class: "app__label--medium",
  style: {"text-align":"center"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"position":"relative","zoom":"0.8","margin-right":"4px","filter":"invert()"}
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = {
  class: "app__color--gray",
  style: {"font-weight":"bold","font-size":"1.5rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.pidOffer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_q_icon, {
            name: "check",
            style: {"font-weight":"bold","font-size":"3rem","color":"#9b7d32"}
          }),
          _createElementVNode("h6", _hoisted_2, _toDisplayString(_ctx.$t('message.request_sent_successfully')), 1),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('message.in_shortest_term')), 1),
          _createElementVNode("p", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('message.request_id')) + " " + _toDisplayString(_ctx.pidOffer), 1)
          ]),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('message.consult_section')), 1),
          _createVNode(_component_q_btn, {
            "no-caps": "",
            onClick: _ctx.onGoToOffers,
            style: {"background-color":"#9b7d32","color":"white"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_icon, { style: {"cursor":"pointer"} }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('message.requests_and_offers')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _hoisted_7,
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('message.thanks')), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}